(function () {
'use strict';
var FAV_KEY = 'tu_hub_favs';
var RECENT_KEY = 'tu_hub_recent';
var RECENT_MAX = 12;
function $(sel, root) { return (root || document).querySelector(sel); }
function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
function read(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } }
function write(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
function money(cents) {
if (cents == null || isNaN(cents)) return '';
return '$' + (cents / 100).toFixed(2);
}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function cardHTML(item, withHeart) {
var img = item.image
? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy" width="150" height="150">'
: '';
var price = item.price ? '<span class="tu-hub-card__price">' + esc(item.price) +
(item.compare ? '<span class="rrp-label">RRP</span> <del>' + esc(item.compare) + '</del>' : '') + '</span>' : '';
var heart = withHeart
? '<button type="button" class="tu-fav tu-fav--overlay is-active" data-tu-fav data-handle="' + esc(item.handle) +
'" data-title="' + esc(item.title) + '" data-url="' + esc(item.url) + '" data-image="' + esc(item.image) +
'" data-price="' + esc(item.price) + '" data-compare="' + esc(item.compare || '') +
'" aria-pressed="true" aria-label="Remove ' + esc(item.title) + ' from favourites">' +
'<svg viewBox="0 0 24 24" aria-hidden="true"><path class="tu-fav-fill" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></button>'
: '';
return '<a class="tu-hub-card" href="' + esc(item.url) + '">' +
'<span class="tu-hub-card__media">' + img + heart + '</span>' +
'<span class="tu-hub-card__title">' + esc(item.title) + '</span>' + price + '</a>';
}
function favs() { return read(FAV_KEY); }
function isFav(handle) { return favs().some(function (f) { return f.handle === handle; }); }
function toggleFav(data) {
var list = favs();
var i = -1, n;
for (n = 0; n < list.length; n++) { if (list[n].handle === data.handle) { i = n; break; } }
var nowActive;
if (i > -1) { list.splice(i, 1); nowActive = false; }
else { list.unshift(data); nowActive = true; }
write(FAV_KEY, list);
reflectFav(data.handle, nowActive);
renderFavs();
renderBadge();
showFavToast(data, nowActive);
return nowActive;
}
var toastTimer;
function showFavToast(data, active) {
var t = $('[data-tu-toast]');
if (!t) {
t = document.createElement('div');
t.className = 'tu-hub-toast';
t.setAttribute('data-tu-toast', '');
t.setAttribute('data-tu-hub-open', '');
t.setAttribute('role', 'status');
document.body.appendChild(t);
}
var thumb = data && data.image ? '<span class="tu-hub-toast__thumb"><img src="' + esc(data.image) + '" alt="" loading="lazy"></span>' : '';
var heart = '<span class="tu-hub-toast__ico"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></span>';
var count = favs().length;
t.classList.toggle('tu-hub-toast--removed', !active);
t.innerHTML = heart + thumb + '<span class="tu-hub-toast__txt">' + (active ? 'Saved to favourites' : 'Removed from favourites') + '</span>' + (active && count ? '<span class="tu-hub-toast__count">' + count + '</span>' : '');
void t.offsetWidth;
t.classList.add('is-shown');
clearTimeout(toastTimer);
toastTimer = setTimeout(function () { t.classList.remove('is-shown'); }, 2800);
}
function reflectFav(handle, active) {
$all('[data-tu-fav][data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]').forEach(function (btn) {
btn.classList.toggle('is-active', active);
btn.setAttribute('aria-pressed', active ? 'true' : 'false');
});
}
function renderBadge() {
var badge = $('[data-tu-fav-badge]');
if (!badge) return;
var c = favs().length;
badge.textContent = c;
badge.hidden = c === 0;
}
function renderFavs() {
var rail = $('[data-tu-favs-rail]'); var empty = $('[data-tu-favs-empty]');
if (!rail) return;
var list = favs();
if (!list.length) { rail.hidden = true; if (empty) empty.hidden = false; rail.innerHTML = ''; return; }
if (empty) empty.hidden = true;
rail.hidden = false;
rail.innerHTML = list.map(function (it) { return cardHTML(it, true); }).join('');
setupRails();
}
function mergeServerFavs() {
// Migrated favourites (back-filled from Klaviyo) are exposed by tu-hub.liquid as
// window.TU_HUB_SERVER_FAVS (an array of product handles) for a logged-in customer.
// Hydrate each via /products/{handle}.js so titles/images/prices are always LIVE, then
// add to the local list. Merge once per distinct server set so the customer's own later
// removals aren't resurrected on the next load.
var srv = window.TU_HUB_SERVER_FAVS;
if (typeof srv === 'string') { try { srv = JSON.parse(srv); } catch (e) { srv = null; } }
if (!srv || !srv.length) return;
var handles = srv.map(function (s) { return typeof s === 'string' ? s : (s && s.handle); }).filter(Boolean);
if (!handles.length) return;
var sig = 'v1:' + handles.slice().sort().join(',');
try { if (localStorage.getItem('tu_hub_srvmerged') === sig) return; } catch (e) {}
var have = {};
favs().forEach(function (f) { have[f.handle] = true; });
var todo = handles.filter(function (h) { return !have[h]; });
if (!todo.length) { try { localStorage.setItem('tu_hub_srvmerged', sig); } catch (e) {} return; }
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var remaining = todo.length;
function done() {
remaining--;
if (remaining > 0) return;
try { localStorage.setItem('tu_hub_srvmerged', sig); } catch (e) {}
renderFavs(); renderBadge(); syncFavButtons(); injectCardHearts();
}
todo.forEach(function (h) {
fetch(root + 'products/' + h + '.js')
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (p) {
if (!p || !p.handle) return;
var cur = favs();
if (cur.some(function (f) { return f.handle === p.handle; })) return;
var onSale = p.compare_at_price && p.compare_at_price > p.price;
cur.push({ handle: p.handle, title: p.title, url: p.url || ('/products/' + p.handle), image: p.featured_image || (p.images && p.images[0]) || '', price: money(p.price), compare: onSale ? money(p.compare_at_price) : '' });
write(FAV_KEY, cur);
})
.catch(function () {})
.then(done);
});
}
function syncFavButtons() {
var saved = {};
favs().forEach(function (f) { saved[f.handle] = true; });
$all('[data-tu-fav]').forEach(function (btn) {
var h = btn.getAttribute('data-handle');
var active = !!saved[h];
btn.classList.toggle('is-active', active);
btn.setAttribute('aria-pressed', active ? 'true' : 'false');
});
}
function dataFromBtn(btn) {
return {
handle: btn.getAttribute('data-handle'),
title: btn.getAttribute('data-title'),
url: btn.getAttribute('data-url'),
image: btn.getAttribute('data-image'),
price: btn.getAttribute('data-price'),
compare: btn.getAttribute('data-compare') || ''
};
}
function injectCardHearts() {
$all('.card__media').forEach(function (media) {
if (media.__tuFav) return;
var scope = media.closest('.card-wrapper') || media.closest('.card') || media.parentElement;
if (!scope) return;
var link = scope.querySelector('a[href*="/products/"]') || media.querySelector('a[href*="/products/"]');
if (!link) return;
var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
if (!m) return;
media.__tuFav = true;
var handle = m[1];
var titleEl = scope.querySelector('.card__heading a, .card__heading, .full-unstyled-link');
var img = media.querySelector('img') || scope.querySelector('img');
var priceWrap = scope.querySelector('.price');
var onSale = !!(priceWrap && priceWrap.classList.contains('price--on-sale'));
var priceEl = (onSale ? scope.querySelector('.price__sale .price-item--sale') : scope.querySelector('.price__regular .price-item--regular')) || scope.querySelector('.price-item--regular');
var compareEl = onSale ? scope.querySelector('.price__sale .price-item--regular') : null;
var data = {
handle: handle,
title: titleEl ? titleEl.textContent.trim() : handle,
url: link.getAttribute('href').split('?')[0],
image: img ? (img.currentSrc || img.src) : '',
price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
compare: compareEl ? compareEl.textContent.replace(/\s+/g, ' ').trim() : ''
};
if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'tu-fav tu-fav--overlay' + (isFav(handle) ? ' is-active' : '');
btn.setAttribute('data-tu-fav', '');
Object.keys(data).forEach(function (k) { btn.setAttribute('data-' + k, data[k]); });
btn.setAttribute('aria-pressed', isFav(handle) ? 'true' : 'false');
btn.setAttribute('aria-label', 'Save to favourites');
btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="tu-fav-fill" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
media.appendChild(btn);
});
}
function injectCartIcon() {
// Mirror the hub launcher into the in-house cart drawer header (#tu-cart). Clicking it
// closes the cart and opens the hub. Clones the live launcher SVG so the icon always matches.
var header = document.querySelector('#tu-cart .tu-cart__header');
if (!header || header.__tuHubIco) return;
var src = document.querySelector('.tu-hub-launcher svg');
if (!src) return;
header.__tuHubIco = true;
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'tu-cart__hub-ico';
btn.setAttribute('aria-label', 'Open your account hub');
btn.appendChild(src.cloneNode(true));
btn.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation();
var c = document.querySelector('#tu-cart .tu-cart__close');
if (c) c.click();
setTimeout(function () { openHub('home'); }, 60);
});
header.insertBefore(btn, header.firstChild);
}
function pdpMediaTarget() {
// Pin to the media ITEM (not the inner .product__media) so Dawn's `.product__media svg`
// fill rules don't stretch our heart to cover the whole image.
return document.querySelector('.product__media-wrapper .product__media-item')
|| document.querySelector('.product__media-list .product__media-item')
|| document.querySelector('.product__media-item')
|| document.querySelector('.product__media-wrapper')
|| document.querySelector('.product__media');
}
function injectPdpHeart(data) {
if (!data || !data.handle) return;
var media = pdpMediaTarget();
if (!media || media.__tuFav) return;
media.__tuFav = true;
if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'tu-fav tu-fav--overlay tu-fav--pdp' + (isFav(data.handle) ? ' is-active' : '');
btn.setAttribute('data-tu-fav', '');
Object.keys(data).forEach(function (k) { btn.setAttribute('data-' + k, data[k] == null ? '' : data[k]); });
btn.setAttribute('aria-pressed', isFav(data.handle) ? 'true' : 'false');
btn.setAttribute('aria-label', 'Save to favourites');
btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="tu-fav-fill" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
// Hard inline styles (with !important) so theme media rules can't restyle the button or SVG.
btn.setAttribute('style', 'position:absolute!important;top:auto!important;left:auto!important;right:12px!important;bottom:12px!important;width:44px!important;height:44px!important;min-width:0!important;flex:0 0 auto!important;padding:0!important;z-index:4!important;');
var svg = btn.firstChild;
if (svg && svg.setAttribute) svg.setAttribute('style', 'width:22px!important;height:22px!important;min-width:0!important;position:static!important;inset:auto!important;display:block!important;flex:0 0 auto!important;');
media.appendChild(btn);
}
function saveRecent(p) {
if (!p || !p.handle) return;
var list = read(RECENT_KEY).filter(function (it) { return it.handle !== p.handle; });
list.unshift(p);
write(RECENT_KEY, list.slice(0, RECENT_MAX));
}
function recordRecent() {
// Prefer a server-rendered blob (tu-hub-track) when present...
var el = $('[data-tu-hub-product]');
if (el) { try { var blob = JSON.parse(el.textContent); saveRecent(blob); injectPdpHeart(blob); } catch (e) {} return; }
// ...otherwise self-detect a product page and fetch the product (no theme edit needed).
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var m = location.pathname.match(/\/products\/([^/?#]+)/);
if (!m) return;
fetch(root + 'products/' + m[1] + '.js')
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (p) {
if (!p || !p.handle) return;
var onSale = p.compare_at_price && p.compare_at_price > p.price;
var data = {
handle: p.handle, title: p.title, url: p.url || ('/products/' + p.handle),
image: p.featured_image || (p.images && p.images[0]) || '',
price: money(p.price), compare: onSale ? money(p.compare_at_price) : ''
};
saveRecent({ id: p.id, handle: data.handle, title: data.title, url: data.url, image: data.image, price: data.price, compare: data.compare });
injectPdpHeart(data);
}).catch(function () {});
}
function renderRecent() {
var sect = $('[data-tu-recent]'); var rail = $('[data-tu-recent-rail]');
if (!sect || !rail) return;
var current = ($('[data-tu-hub-product]') ? (function () { try { return JSON.parse($('[data-tu-hub-product]').textContent).handle; } catch (e) { return null; } })() : null);
var list = read(RECENT_KEY).filter(function (it) { return it.handle !== current; });
if (!list.length) { sect.hidden = true; return; }
sect.hidden = false;
rail.innerHTML = list.map(function (it) { return cardHTML(it, false); }).join('');
setupRails();
}
var picksLoaded = false;
function loadPicks() {
if (picksLoaded) return;
var sect = $('[data-tu-picks]'); var rail = $('[data-tu-picks-rail]');
if (!sect || !rail) return;
var recent = read(RECENT_KEY);
var seed = recent[0] && recent[0].id;
if (!seed) return; // keep the server-rendered fallback collection (if any)
picksLoaded = true;
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&intent=related&limit=8')
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (data) {
if (!data || !data.products || !data.products.length) return;
var items = data.products.map(function (p) {
var onSale = p.compare_at_price && p.compare_at_price > p.price;
return {
handle: p.handle, title: p.title, url: p.url,
image: p.featured_image || (p.images && p.images[0]) || '',
price: money(p.price), compare: onSale ? money(p.compare_at_price) : ''
};
});
rail.innerHTML = items.map(function (it) { return cardHTML(it, false); }).join('');
sect.hidden = false;
setupRails();
})
.catch(function () { picksLoaded = false; });
}
function railStep(rail) {
var card = rail.querySelector('.tu-hub-card');
return (card ? card.offsetWidth : 130) + 11;
}
function updateRailArrows(rail) {
var wrap = rail.parentNode;
if (!wrap || !wrap.classList || !wrap.classList.contains('tu-hub__rail-wrap')) return;
var prev = wrap.querySelector('[data-tu-rail-prev]');
var next = wrap.querySelector('[data-tu-rail-next]');
var max = rail.scrollWidth - rail.clientWidth;
var overflow = max > 4;
if (prev) prev.hidden = !(overflow && rail.scrollLeft > 4);
if (next) next.hidden = !(overflow && rail.scrollLeft < max - 4);
}
function setupRail(rail) {
if (!rail.__tuRail) {
rail.__tuRail = true;
var wrap = document.createElement('div');
wrap.className = 'tu-hub__rail-wrap';
rail.parentNode.insertBefore(wrap, rail);
wrap.appendChild(rail);
['prev', 'next'].forEach(function (dir) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'tu-hub__rail-arrow tu-hub__rail-arrow--' + dir;
b.setAttribute('data-tu-rail-' + dir, '');
b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
b.hidden = true;
b.innerHTML = '<svg class="tu-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M' + (dir === 'prev' ? '15 6l-6 6 6 6' : '9 6l6 6-6 6') + '"/></svg>';
b.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation();
rail.scrollBy({ left: (dir === 'prev' ? -2 : 2) * railStep(rail), behavior: 'smooth' });
});
wrap.appendChild(b);
});
rail.addEventListener('scroll', function () { updateRailArrows(rail); }, { passive: true });
}
updateRailArrows(rail);
}
function setupRails() {
if (!hub) return;
$all('.tu-hub__rail', hub).forEach(setupRail);
}
// Shopify Inbox host. The 2026 "agent chat" update replaced the old #ShopifyChat div with a
// <shopify-chat> custom element (shadow DOM: #shopify-element-wrapper > .activator-nudge >
// button.activator). Old selectors kept as fallbacks in case the legacy widget returns.
function inboxHost() { return document.querySelector('shopify-chat') || document.getElementById('ShopifyChat') || document.querySelector('#ShopifyChat'); }
function inboxIsNew(h) { return !!(h && h.tagName && h.tagName.toLowerCase() === 'shopify-chat'); }
function inboxToggle() {
var host = inboxHost();
if (!host || !host.shadowRoot) return null;
// New agent chat nests the activator inside <shopify-agent-runtime>'s own shadow root.
var rt = host.shadowRoot.querySelector('shopify-agent-runtime');
var nested = rt && rt.shadowRoot && rt.shadowRoot.querySelector('button.activator, [part~="activator"]');
if (nested) return nested;
return host.shadowRoot.querySelector('button.activator, .chat-toggle, .chat-app > button, button[aria-controls="chat-ui"], button');
}
function inboxIsOpen() {
var h = inboxHost();
if (!h) return false;
// New agent chat: the <shopify-chat> host carries an [open] attribute while the window is open.
if (inboxIsNew(h)) return h.hasAttribute('open');
var app = h.shadowRoot && h.shadowRoot.querySelector('.chat-app');
return !!(app && app.classList.contains('chat-app--is-open'));
}
function watchInbox() {
var tries = 0;
var iv = setInterval(function () {
tries++;
var h = inboxHost();
if (h && h.shadowRoot && h.shadowRoot.querySelector('button.activator, shopify-agent-runtime, .chat-app, .chat-toggle')) {
clearInterval(iv);
// Don't hide a chat that's currently open (Inbox persists open state across page loads).
if (!inboxIsOpen()) document.documentElement.classList.add('tu-hub-inbox-hidden');
document.documentElement.classList.toggle('tu-hub-chat-open', inboxIsOpen());
watchInboxClose();
} else if (tries > 40) { clearInterval(iv); } // ~20s; Inbox not present
}, 500);
}
function watchInboxClose() {
// Once chat is open, re-hide Inbox's bubble when the window is closed so the hub stays
// the single button.
var host = inboxHost();
if (!host || !window.MutationObserver) return;
if (inboxIsNew(host)) {
// New agent chat: open/closed is the [open] attribute on the host itself — observe that.
if (host.__tuWatched) return;
host.__tuWatched = true;
new MutationObserver(function () {
var chatOpen = host.hasAttribute('open');
document.documentElement.classList.toggle('tu-hub-chat-open', chatOpen);
if (!chatOpen) document.documentElement.classList.add('tu-hub-inbox-hidden');
}).observe(host, { attributes: true, attributeFilter: ['open'] });
return;
}
// Legacy widget: observe chat-app--is-open inside the shadow DOM.
var app = host.shadowRoot && host.shadowRoot.querySelector('.chat-app');
if (!app || app.__tuWatched) return;
app.__tuWatched = true;
new MutationObserver(function () {
var chatOpen = app.classList.contains('chat-app--is-open');
document.documentElement.classList.toggle('tu-hub-chat-open', chatOpen);
if (!chatOpen) document.documentElement.classList.add('tu-hub-inbox-hidden');
}).observe(app, { attributes: true, attributeFilter: ['class'] });
}
function openInbox() {
document.documentElement.classList.remove('tu-hub-inbox-hidden');
// Already open (new widget removes its activator while open — a blind click could hit
// a button inside the chat window): just surface it and keep the state classes right.
if (inboxIsOpen()) { document.documentElement.classList.add('tu-hub-chat-open'); watchInboxClose(); return; }
var attempts = 0;
(function tryClick() {
var h = inboxHost();
// New agent chat (Oct 2026+): use the widget's public show() API. Its "Chat" activator now
// sits a shadow level deeper (inside <shopify-agent-runtime>), so clicking it from here
// only revealed the pill instead of opening the window.
if (inboxIsNew(h) && typeof h.show === 'function') {
try { h.show(); } catch (e) {}
setTimeout(watchInboxClose, 150);
if (h.hasAttribute('open')) { document.documentElement.classList.add('tu-hub-chat-open'); return; }
if (attempts++ < 12) { setTimeout(tryClick, 250); return; }
}
var t = inboxToggle();
if (t) { t.click(); setTimeout(watchInboxClose, 150); return; }
if (attempts++ < 12) { setTimeout(tryClick, 250); return; }
var host = inboxHost();
if (host) { try { host.scrollIntoView(); } catch (e) {} }
})();
}
function storeCredit() {
// Available store-credit balance, read from the Redeemly (mcb) launcher global the app
// renders site-wide. Returns null while the global isn't ready yet (so we can retry),
// or {amount, text} once it is. amount === 0 means a logged-in customer with no credit.
try {
var c = window.mcb_launcher && window.mcb_launcher.customer;
if (!window.mcb_launcher) return null;        // app block not parsed yet → retry
if (!c) return { amount: 0, text: '' };         // guest / logged-out → no credit line
var b = c.liquidStoreCreditBalance || {};
var amt = typeof b.amount === 'number' ? b.amount : parseFloat(b.amount);
if (!amt || amt <= 0) return { amount: 0, text: '' };
var text = (b.formattedAmount && String(b.formattedAmount).trim()) || ('$' + (amt % 1 === 0 ? amt : amt.toFixed(2)));
return { amount: amt, text: text };
} catch (e) { return null; }
}
var creditTries = 0;
function renderStoreCredit() {
var line = $('[data-tu-credit]');
if (!line) return;
var c = storeCredit();
if (c && c.amount > 0) {
var amtEl = $('[data-tu-credit-amt]', line);
if (amtEl) amtEl.textContent = c.text;
line.hidden = false;
return;
}
line.hidden = true;
// The mcb launcher's inline script runs near </body>; if it isn't there yet, retry briefly.
if (c === null && creditTries < 20) { creditTries++; setTimeout(renderStoreCredit, 300); }
}
var hub, lastFocus;
function setTab(name) {
$all('[data-tu-tab]').forEach(function (t) {
var on = t.getAttribute('data-tu-tab') === name;
t.classList.toggle('is-active', on);
t.hidden = !on;
});
$all('[data-tu-go]').forEach(function (b) {
b.classList.toggle('is-active', b.getAttribute('data-tu-go') === name);
});
var body = $('.tu-hub__body'); if (body) body.scrollTop = 0;
}
function openHub(tab) {
if (!hub) return;
lastFocus = document.activeElement;
hub.classList.add('is-open');
hub.setAttribute('aria-hidden', 'false');
document.body.style.overflow = 'hidden';
document.documentElement.classList.add('tu-hub-open');
setTab(tab || 'home');
renderRecent(); renderFavs(); renderBadge(); syncFavButtons(); loadPicks(); renderStoreCredit(); setupRails();
var close = $('[data-tu-hub-close].tu-hub__close', hub) || $('.tu-hub__close', hub);
if (close) close.focus();
}
function closeHub() {
if (!hub) return;
hub.classList.remove('is-open');
hub.setAttribute('aria-hidden', 'true');
document.body.style.overflow = '';
document.documentElement.classList.remove('tu-hub-open');
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
function trapFocus(e) {
if (e.key !== 'Tab' || !hub.classList.contains('is-open')) return;
var f = $all('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', hub)
.filter(function (el) { return el.offsetParent !== null; });
if (!f.length) return;
var first = f[0], last = f[f.length - 1];
if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}
function onClick(e) {
var openBtn = e.target.closest('[data-tu-hub-open]');
if (openBtn) { e.preventDefault(); openHub('home'); return; }
var acct = e.target.closest('.header__icon--account, .header a[href*="/account"], .header a[href*="account.traveluniverse"], .menu-drawer a[href*="/account"], .menu-drawer a[href*="account.traveluniverse"]');
if (acct && !acct.closest('.tu-hub')) { e.preventDefault(); e.stopPropagation(); openHub('home'); return; }
var fav = e.target.closest('[data-tu-fav]');
if (fav) {
e.preventDefault(); e.stopPropagation();
fav.classList.add('tu-fav--pop');
setTimeout(function () { fav.classList.remove('tu-fav--pop'); }, 320);
toggleFav(dataFromBtn(fav));
return;
}
if (!hub) return;
if (hub.classList.contains('is-open') && !e.target.closest('.tu-hub__panel')) { closeHub(); return; }
if (e.target.closest('[data-tu-hub-close]')) { e.preventDefault(); closeHub(); return; }
var go = e.target.closest('[data-tu-go]');
if (go) { setTab(go.getAttribute('data-tu-go')); return; }
var chat = e.target.closest('[data-tu-chat]');
if (chat) { e.preventDefault(); closeHub(); setTimeout(openInbox, 320); return; }
var faqQ = e.target.closest('[data-tu-faq-q]');
if (faqQ) {
var item = faqQ.closest('[data-tu-faq]');
var panel = item.querySelector('[data-tu-faq-a]');
var open = item.classList.toggle('is-open');
faqQ.setAttribute('aria-expanded', open ? 'true' : 'false');
panel.style.maxHeight = open ? (panel.scrollHeight + 'px') : '';
if (open) {
$all('img', panel).forEach(function (im) {
if (!im.complete) im.addEventListener('load', function () { if (item.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px'; }, false);
});
}
return;
}
}
function onHeartCapture(e) {
// Capture-phase, geometry-based: if the click lands within a heart's box, handle it here —
// beats any theme card/link overlay that would otherwise swallow the click and navigate.
if (typeof e.button === 'number' && e.button !== 0) return;
if (e.target.closest && e.target.closest('.tu-hub__rail-arrow')) return;
var hearts = $all('[data-tu-fav]');
for (var i = 0; i < hearts.length; i++) {
var b = hearts[i];
var r = b.getBoundingClientRect();
if (!r.width || !r.height) continue;
if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
e.preventDefault();
e.stopPropagation();
if (e.stopImmediatePropagation) e.stopImmediatePropagation();
b.classList.add('tu-fav--pop');
(function (btn) { setTimeout(function () { btn.classList.remove('tu-fav--pop'); }, 320); })(b);
toggleFav(dataFromBtn(b));
return;
}
}
}
function init() {
hub = $('[data-tu-hub]');
mergeServerFavs();
recordRecent();
syncFavButtons();
renderBadge();
renderStoreCredit();
injectCardHearts();
injectCartIcon();
watchInbox();
document.addEventListener('click', onHeartCapture, true);
document.addEventListener('click', onClick);
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && hub && hub.classList.contains('is-open')) closeHub();
else trapFocus(e);
});
if (window.MutationObserver) {
var t;
var mo = new MutationObserver(function () {
clearTimeout(t);
t = setTimeout(function () { injectCardHearts(); injectCartIcon(); }, 250);
});
mo.observe(document.body, { childList: true, subtree: true });
}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
